import React from 'react';
import { type Coverage, CoverageSection } from './Coverage';

export interface TrustedProps {
  title: string;
  subtitle: string;
  data: Coverage[];
  darkBackground?: boolean;
}

const Trusted: React.FC<TrustedProps> = ({ data, title, subtitle, darkBackground }) => {
  return <CoverageSection title={title} subtitle={subtitle} coverages={data} darkBackground={darkBackground} />;
};

export default React.memo(Trusted);
